import { View, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import locale from "date-fns/locale/en-US";

import Toolbar from "./calendarToolbar";

const today = new Date();
export const DEFAULT_TIMEZONE = "America/Chicago";
export const EVENT_DURATION = 25;
export const SLOT_DURATION = 30;
const locales = {
  "en-US": locale,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});
const minHourStart = new Date(
  today.getFullYear(),
  today.getMonth(),
  today.getDate(),
  0
);

const hourEnd = new Date(
  today.getFullYear(),
  today.getMonth(),
  today.getDate(),
  23
);

export const agendaSettings = {
  min: minHourStart,
  max: hourEnd,
  timeslots: 1,
  views: ["month", "week", "day"] as View[],
  selectable: true,
  localizer,
  step: SLOT_DURATION,
  longPressThreshold: 1,
  components: {
    toolbar: (props, children) => <Toolbar {...props}>{children}</Toolbar>,
  },
};
